// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"e50a0a65","99":"e0502a62","146":"23844537","175":"a0b07e11","204":"123af65f","349":"be6456a0","453":"65feab6d","479":"bde73e37","655":"b354bda1","674":"9f917e7b","768":"de7941b5","813":"f8ebb096","963":"1deb49a3"}[chunkId] + ".chunk.js";
};